export default __webpack_public_path__ + "static/media/unliked.51e7dfff.svg";